import { useEffect, MutableRefObject } from "react";

const events = ["mousedown", "touchstart"];

export function useOnClickOutside(
  ref: MutableRefObject<any>,
  handler: (e: Event) => void
) {
  useEffect(() => {
    const fn = (event: Event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    events.forEach((e) => document.addEventListener(e, fn, { passive: true }));

    return () => events.forEach((e) => document.removeEventListener(e, fn));
  }, []);
}
